import { render, staticRenderFns } from "./HoldOrderModal.vue?vue&type=template&id=03f83296&scoped=true"
import script from "./HoldOrderModal.vue?vue&type=script&lang=js"
export * from "./HoldOrderModal.vue?vue&type=script&lang=js"
import style0 from "./HoldOrderModal.vue?vue&type=style&index=0&id=03f83296&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f83296",
  null
  
)

export default component.exports